import { types } from '../../../constants/ActionTypes'
import dateformat from 'dateformat'
import { deepCopy } from '../../../lib'
import { puzzle as limit } from '../../../constants/Limit';

const initialState = {
  pathname: '',
  activeStep: 0,
  title: '',
  type: '',
  level: '',
  datetime: dateformat(new Date(), "isoDateTime").slice(0, -8),
  checkDateTime: false,
  tag: '',
  tags: [],
  isOtherAnswers: 1,
  comment: '',
  isFetching: false,
  isCompleted: false,
  result: false,
  ready: false,
  openConfirmDialog: false,
}

const puzzleRegister = (state = initialState, action) => {
  var tag, newTags, record, comment
  switch (action.type) {
    case types.puzzleRegister.INIT:
      return { ...deepCopy(initialState) }
    case types.puzzleRegister.NEXT:
      return {
        ...state,
        activeStep: state.activeStep + 1,
      }
    case types.puzzleRegister.BACK:
      return {
        ...state,
        activeStep: state.activeStep - 1
      }
    case types.puzzleRegister.BACK_FIRST:
      return {
        ...state,
        activeStep: 0,
        isCompleted: false,
        result: false,
      }
    case types.puzzleRegister.SELECTED_STEP:
      return {
        ...state,
        activeStep: action.step,
      }
    case types.puzzleRegister.CHANGED_TEXT:
      if (
        action.name === 'tag' &&
        action.text.length > state.tag.length &&
        action.text.length <= limit.stringLength['tag'] &&
        state.tags.length < 5 &&
        (action.text[action.text.length - 1] === ' ' || action.text[action.text.length - 1] === '　')
      ) {
        tag = action.text.slice(0, action.text.length - 1)
        if (tag.length === 0) {
          return state
        }
        newTags = deepCopy(state.tags)
        newTags.push(tag)
        return {
          ...state,
          tag: '',
          tags: newTags,
        }
      }
      if (
        limit.stringLength[action.name] &&
        action.text.length > limit.stringLength[action.name]
      ) {
        return state
      }
      return {
        ...state,
        [action.name]: action.text,
      }
    case types.puzzleRegister.CHANGED_CHECKBOX:
      return {
        ...state,
        [action.name]: action.checked,
      }
    case types.puzzleRegister.ADD_TAG:
      if (state.tag.length === 0 || state.tags.length >= 5) {
        return state
      }
      newTags = deepCopy(state.tags)
      newTags.push(state.tag)
      return {
        ...state,
        tag: '',
        tags: newTags,
      }
    case types.puzzleRegister.REMOVE_TAG:
      return {
        ...state,
        tags: state.tags.filter((tag, index) => index !== action.index )
      }
    case types.puzzleRegister.confirmDialog.OPEN:
      return { ...state, openConfirmDialog: true }
    case types.puzzleRegister.confirmDialog.CLOSE:
      return { ...state, openConfirmDialog: false }
    case types.fetch.puzzle.REQUEST_ADD:
    case types.fetch.puzzle.REQUEST_UPDATE:
      return {
        ...state,
        isFetching: true,
      }
    case types.fetch.puzzle.RESPONSE_ADD:
    case types.fetch.puzzle.RESPONSE_UPDATE:
      return {
        ...state,
        isFetching: false,
        isCompleted: true,
        result: action.response.result,
      }
    case types.puzzleRegister.RESPONSE_SELECT_PUZZLE:
      if (
        action.response.result !== true ||
        action.response.records.length !== 1
      ) {
        return state
      }
      record = action.response.records[0]
      if (record.comments.length > 0 && record.comments[0].isAuthor) {
        comment = record.comments[0].comment
      }
      return {
        ...state,
        title: record.title,
        checkDateTime: Boolean(new Date(record.datetime) > Date.now()),
        datetime: dateformat(new Date(record.datetime), "isoDateTime").slice(0, -8),
        type: record.pt,
        level: record.lv.toString(10),
        tags: record.tags,
        isOtherAnswers: record.isOtherAnswers,
        comment: comment,
        ready: true,
      }
    default:
      return state
  }
}

export default puzzleRegister



// WEBPACK FOOTER //
// ./src/reducers/Page/Puzzle/PuzzleRegister.js